import { BaseDto } from './base.dto';
import { MerchantOrderStatusPrinterDto } from './merchantOrderStatusPrinter.dto';
import { PosDeviceDto } from './posDevice.dto';
import { PrinterTypeDto } from './printerType.dto';

export class MerchantPrinterDto extends BaseDto {
  name: string;
  ip: string;
  port: string;
  disabledDate: Date;
  createdDate?: Date;
  printerType: PrinterTypeDto;
  merchantOrderStatusPrinters?: MerchantOrderStatusPrinterDto[];
  merchantId: number;
  isEnabled?: boolean;
  posDeviceId?: number;
  posDevice: PosDeviceDto;
  assignedPosDevices?: PosDeviceDto[];
  backupPrinterId?: number;
}
